import { useState, useCallback, useRef, useEffect } from 'react';
import { supabase } from './supabaseClient';

// ── Styles ────────────────────────────────────────────────────────────────────

const styles = {
  app: {
    minHeight: '100vh',
    background: '#f4f3f0',
    fontFamily: "'DM Sans', 'Helvetica Neue', sans-serif",
    display: 'flex',
    flexDirection: 'column',
  },
  header: {
    background: '#2D2A5E',
    padding: '0 24px',
    height: '56px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    flexShrink: 0,
  },
  headerTitle: {
    color: '#fff',
    fontSize: '15px',
    fontWeight: '600',
    letterSpacing: '0.04em',
    textTransform: 'uppercase',
  },
  tabBar: {
    background: '#fff',
    display: 'flex',
    borderBottom: '2px solid #eeecea',
    flexShrink: 0,
  },
  tab: {
    flex: 1,
    padding: '14px',
    border: 'none',
    background: 'none',
    cursor: 'pointer',
    fontSize: '13px',
    fontWeight: '600',
    letterSpacing: '0.05em',
    textTransform: 'uppercase',
    color: '#aaa',
    borderBottom: '2px solid transparent',
    marginBottom: '-2px',
    fontFamily: 'inherit',
  },
  tabActive: {
    color: '#2D2A5E',
    borderBottom: '2px solid #2D2A5E',
  },
  body: {
    flex: 1,
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    padding: '24px 16px',
    gap: '14px',
    maxWidth: '560px',
    width: '100%',
    margin: '0 auto',
    boxSizing: 'border-box',
  },
  stepCard: {
    background: '#fff',
    borderRadius: '12px',
    padding: '20px',
    width: '100%',
    boxSizing: 'border-box',
    boxShadow: '0 1px 3px rgba(0,0,0,0.06), 0 4px 16px rgba(0,0,0,0.04)',
  },
  stepLabel: {
    fontSize: '10px',
    fontWeight: '700',
    letterSpacing: '0.1em',
    textTransform: 'uppercase',
    color: '#2D2A5E',
    marginBottom: '10px',
  },
  toggleRow: {
    display: 'flex',
    gap: '8px',
    marginBottom: '14px',
  },
  toggleBtn: {
    flex: 1,
    padding: '8px',
    borderRadius: '6px',
    border: '1.5px solid #e8e7e4',
    background: '#fafaf9',
    cursor: 'pointer',
    fontSize: '12px',
    fontWeight: '600',
    letterSpacing: '0.04em',
    textTransform: 'uppercase',
    color: '#999',
    fontFamily: 'inherit',
  },
  toggleBtnActive: {
    background: '#f0eff9',
    border: '1.5px solid #2D2A5E',
    color: '#2D2A5E',
  },
  inputWrap: {
    position: 'relative',
  },
  input: {
    width: '100%',
    padding: '12px 14px',
    borderRadius: '8px',
    border: '1.5px solid #e8e7e4',
    fontSize: '14px',
    fontFamily: 'inherit',
    outline: 'none',
    background: '#fafaf9',
    color: '#1a1a2e',
    boxSizing: 'border-box',
  },
  inputFocused: {
    border: '1.5px solid #2D2A5E',
    background: '#fff',
  },
  dropdown: {
    position: 'absolute',
    top: 'calc(100% + 4px)',
    left: 0,
    right: 0,
    background: '#fff',
    borderRadius: '8px',
    boxShadow: '0 8px 32px rgba(0,0,0,0.12)',
    border: '1px solid #efefed',
    zIndex: 50,
    maxHeight: '240px',
    overflowY: 'auto',
  },
  dropdownItem: {
    padding: '11px 14px',
    cursor: 'pointer',
    fontSize: '13px',
    color: '#333',
    borderBottom: '1px solid #f5f5f3',
  },
  dropdownItemSub: {
    fontSize: '11px',
    color: '#999',
    marginTop: '2px',
  },
  dropdownMessage: {
    padding: '14px',
    fontSize: '13px',
    color: '#999',
    textAlign: 'center',
  },
  selectedPill: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    padding: '10px 14px',
    background: '#f0eff9',
    borderRadius: '8px',
    border: '1.5px solid #2D2A5E',
  },
  selectedInfo: {
    flex: 1,
  },
  selectedName: {
    fontSize: '14px',
    fontWeight: '600',
    color: '#2D2A5E',
  },
  selectedSub: {
    fontSize: '12px',
    color: '#777',
    marginTop: '2px',
  },
  clearBtn: {
    background: 'none',
    border: 'none',
    cursor: 'pointer',
    color: '#aaa',
    fontSize: '18px',
    padding: '0 0 0 12px',
    lineHeight: 1,
    flexShrink: 0,
  },
  resultCard: {
    background: '#2D2A5E',
    borderRadius: '12px',
    padding: '20px',
    width: '100%',
    boxSizing: 'border-box',
    boxShadow: '0 4px 24px rgba(45,42,94,0.2)',
  },
  resultLabel: {
    fontSize: '10px',
    fontWeight: '700',
    letterSpacing: '0.1em',
    textTransform: 'uppercase',
    color: 'rgba(255,255,255,0.4)',
    marginBottom: '12px',
  },
  resultBrand: {
    fontSize: '20px',
    fontWeight: '700',
    color: '#fff',
    marginBottom: '16px',
    letterSpacing: '-0.01em',
  },
  resultDistributor: {
    fontSize: '15px',
    fontWeight: '600',
    color: '#fff',
    marginBottom: '4px',
  },
  resultAddress: {
    fontSize: '13px',
    color: 'rgba(255,255,255,0.6)',
    lineHeight: '1.5',
  },
  divider: {
    height: '1px',
    background: 'rgba(255,255,255,0.1)',
    margin: '14px 0',
  },
  noResult: {
    padding: '20px',
    textAlign: 'center',
    fontSize: '13px',
    color: '#999',
  },
  disabledCard: {
    opacity: 0.4,
    pointerEvents: 'none',
  },
  // Who services my store
  expandBtn: {
    width: '100%',
    marginTop: '12px',
    padding: '10px 14px',
    borderRadius: '8px',
    border: '1.5px solid #e8e7e4',
    background: '#fafaf9',
    cursor: 'pointer',
    fontSize: '12px',
    fontWeight: '600',
    letterSpacing: '0.04em',
    textTransform: 'uppercase',
    color: '#2D2A5E',
    fontFamily: 'inherit',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
  },
  serviceSection: {
    width: '100%',
    boxSizing: 'border-box',
  },
  serviceSectionLabel: {
    fontSize: '10px',
    fontWeight: '700',
    letterSpacing: '0.1em',
    textTransform: 'uppercase',
    color: '#2D2A5E',
    margin: '16px 0 8px',
  },
  serviceCard: {
    background: '#fff',
    borderRadius: '10px',
    padding: '14px 16px',
    marginBottom: '8px',
    boxShadow: '0 1px 3px rgba(0,0,0,0.06)',
    display: 'flex',
    alignItems: 'flex-start',
    justifyContent: 'space-between',
    gap: '12px',
  },
  serviceCardInfo: {
    flex: 1,
  },
  serviceCardName: {
    fontSize: '13px',
    fontWeight: '600',
    color: '#1a1a2e',
    marginBottom: '3px',
  },
  serviceCardAddr: {
    fontSize: '11px',
    color: '#999',
    lineHeight: '1.5',
  },
  serviceCardPhone: {
    fontSize: '11px',
    color: '#2D2A5E',
    marginTop: '3px',
    fontWeight: '500',
  },
  serviceCardBadge: {
    background: '#f0eff9',
    borderRadius: '6px',
    padding: '4px 8px',
    fontSize: '11px',
    fontWeight: '700',
    color: '#2D2A5E',
    flexShrink: 0,
    whiteSpace: 'nowrap',
  },
  // Catalog
  brandListWrap: {
    width: '100%',
    boxSizing: 'border-box',
  },
  brandRow: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    padding: '12px 14px',
    background: '#fff',
    borderRadius: '8px',
    marginBottom: '6px',
    cursor: 'pointer',
    boxShadow: '0 1px 3px rgba(0,0,0,0.05)',
    fontSize: '13px',
    color: '#1a1a2e',
    fontWeight: '500',
  },
  brandRowActive: {
    background: '#f0eff9',
    border: '1.5px solid #2D2A5E',
  },
  brandRowChevron: {
    color: '#ccc',
    fontSize: '16px',
    flexShrink: 0,
  },
  coverageWrap: {
    background: '#2D2A5E',
    borderRadius: '12px',
    padding: '20px',
    width: '100%',
    boxSizing: 'border-box',
    boxShadow: '0 4px 24px rgba(45,42,94,0.2)',
    marginBottom: '6px',
  },
  coverageTitle: {
    fontSize: '10px',
    fontWeight: '700',
    letterSpacing: '0.1em',
    textTransform: 'uppercase',
    color: 'rgba(255,255,255,0.4)',
    marginBottom: '8px',
  },
  coverageBrand: {
    fontSize: '18px',
    fontWeight: '700',
    color: '#fff',
    marginBottom: '16px',
  },
  coverageRow: {
    display: 'flex',
    alignItems: 'flex-start',
    justifyContent: 'space-between',
    padding: '8px 0',
    borderBottom: '1px solid rgba(255,255,255,0.08)',
    gap: '12px',
  },
  coverageCounty: {
    fontSize: '13px',
    color: '#fff',
    fontWeight: '500',
    flex: 1,
  },
  coverageSection: {
    fontSize: '11px',
    fontWeight: '700',
    letterSpacing: '0.06em',
    flexShrink: 0,
  },
  coverageSectionAll: {
    color: 'rgba(255,255,255,0.4)',
  },
  coverageSectionPart: {
    color: '#f0c040',
    cursor: 'pointer',
    textDecoration: 'underline',
    textUnderlineOffset: '2px',
  },
  coverageExplanation: {
    fontSize: '11px',
    color: 'rgba(255,255,255,0.5)',
    marginTop: '2px',
    fontStyle: 'italic',
  },
  paginationRow: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    width: '100%',
    padding: '8px 0',
    boxSizing: 'border-box',
  },
  pageBtn: {
    padding: '8px 18px',
    borderRadius: '8px',
    border: '1.5px solid #e8e7e4',
    background: '#fff',
    cursor: 'pointer',
    fontSize: '13px',
    fontWeight: '600',
    color: '#2D2A5E',
    fontFamily: 'inherit',
  },
  pageBtnDisabled: {
    opacity: 0.3,
    pointerEvents: 'none',
  },
  pageInfo: {
    fontSize: '12px',
    color: '#999',
    fontWeight: '500',
  },
  // Modal
  modalOverlay: {
    position: 'fixed',
    top: 0, left: 0, right: 0, bottom: 0,
    background: 'rgba(0,0,0,0.5)',
    display: 'flex',
    alignItems: 'flex-end',
    justifyContent: 'center',
    zIndex: 1000,
  },
  modalSheet: {
    background: '#fff',
    borderRadius: '16px 16px 0 0',
    padding: '24px',
    width: '100%',
    maxWidth: '560px',
    maxHeight: '80vh',
    overflowY: 'auto',
    boxSizing: 'border-box',
  },
  modalHandle: {
    width: '40px',
    height: '4px',
    background: '#e0e0e0',
    borderRadius: '2px',
    margin: '0 auto 20px',
  },
  modalTitle: {
    fontSize: '10px',
    fontWeight: '700',
    letterSpacing: '0.1em',
    textTransform: 'uppercase',
    color: '#2D2A5E',
    marginBottom: '6px',
  },
  modalBrand: {
    fontSize: '18px',
    fontWeight: '700',
    color: '#1a1a2e',
    marginBottom: '4px',
  },
  modalTerritory: {
    fontSize: '13px',
    color: '#777',
    marginBottom: '20px',
  },
  modalDistCard: {
    background: '#f7f7f5',
    borderRadius: '10px',
    padding: '14px',
    marginBottom: '10px',
  },
  modalDistName: {
    fontSize: '14px',
    fontWeight: '600',
    color: '#1a1a2e',
    marginBottom: '6px',
  },
  modalDistExplanation: {
    fontSize: '13px',
    color: '#555',
    lineHeight: '1.5',
    fontStyle: 'italic',
  },
  modalDistNoExplanation: {
    fontSize: '13px',
    color: '#aaa',
    fontStyle: 'italic',
  },
  modalCloseBtn: {
    width: '100%',
    marginTop: '16px',
    padding: '12px',
    borderRadius: '8px',
    border: 'none',
    background: '#2D2A5E',
    color: '#fff',
    fontSize: '13px',
    fontWeight: '600',
    cursor: 'pointer',
    fontFamily: 'inherit',
  },
};

const PAGE_SIZE = 50;

function useDebounce(value, delay) {
  const [debounced, setDebounced] = useState(value);
  useEffect(() => {
    const t = setTimeout(() => setDebounced(value), delay);
    return () => clearTimeout(t);
  }, [value, delay]);
  return debounced;
}

function SearchInput({ value, onChange, onFocus, onBlur, placeholder, disabled, focused }) {
  return (
    <input
      style={{
        ...styles.input,
        ...(focused ? styles.inputFocused : {}),
        ...(disabled ? { opacity: 0.5 } : {}),
      }}
      value={value}
      onChange={e => onChange(e.target.value)}
      onFocus={onFocus}
      onBlur={onBlur}
      placeholder={placeholder}
      disabled={disabled}
      autoComplete="off"
      spellCheck={false}
    />
  );
}

// ── Part Territory Modal ──────────────────────────────────────────────────────

function PartTerritoryModal({ brand, territory, displayName, onClose }) {
  const [details, setDetails] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    supabase
      .rpc('get_part_territory_details', {
        p_brand: brand,
        p_territory: territory,
      })
      .then(({ data, error }) => {
        if (error) console.error('Part territory details error:', error);
        setDetails(data || []);
        setLoading(false);
      });
  }, [brand, territory]);

  return (
    <div style={styles.modalOverlay} onClick={onClose}>
      <div style={styles.modalSheet} onClick={e => e.stopPropagation()}>
        <div style={styles.modalHandle} />
        <div style={styles.modalTitle}>Partial Territory Detail</div>
        <div style={styles.modalBrand}>{brand}</div>
        <div style={styles.modalTerritory}>{displayName}</div>

        {loading && (
          <div style={styles.dropdownMessage}>Loading details…</div>
        )}

        {!loading && details.map((d, i) => (
          <div key={i} style={styles.modalDistCard}>
            <div style={styles.modalDistName}>{d.trade_name}</div>
            {d.explanation_of_part_territory?.trim() ? (
              <div style={styles.modalDistExplanation}>
                "{d.explanation_of_part_territory.trim()}"
              </div>
            ) : (
              <div style={styles.modalDistNoExplanation}>
                No explanation provided
              </div>
            )}
          </div>
        ))}

        <button style={styles.modalCloseBtn} onClick={onClose}>Close</button>
      </div>
    </div>
  );
}

// ── Who Services My Store ─────────────────────────────────────────────────────

function WhoServicesMyStore({ county }) {
  const [expanded, setExpanded] = useState(false);
  const [loading, setLoading] = useState(false);
  const [wineDistributors, setWineDistributors] = useState([]);
  const [beerDistributors, setBeerDistributors] = useState([]);
  const [loaded, setLoaded] = useState(false);

  const handleExpand = useCallback(async () => {
    setExpanded(prev => !prev);
    if (loaded) return;
    setLoading(true);
    const { data, error } = await supabase
      .rpc('get_top_distributors_by_county', { p_county: county });
    if (error) { console.error('Top distributors error:', error); setLoading(false); return; }
    const wine = (data || []).filter(d => d.report_type === 'Wholesale Wine Distributors').slice(0, 5);
    const beer = (data || []).filter(d => d.report_type === 'Virginia Beer Distributors').slice(0, 5);
    setWineDistributors(wine);
    setBeerDistributors(beer);
    setLoaded(true);
    setLoading(false);
  }, [county, loaded]);

  const formatPhone = (phone) => {
    if (!phone) return null;
    const cleaned = phone.replace(/\D/g, '');
    if (cleaned.length === 10) return `(${cleaned.slice(0,3)}) ${cleaned.slice(3,6)}-${cleaned.slice(6)}`;
    return phone;
  };

  return (
    <>
      <button style={styles.expandBtn} onClick={handleExpand}>
        <span>Who services this area?</span>
        <span>{expanded ? '▲' : '▼'}</span>
      </button>
      {expanded && (
        <div style={styles.serviceSection}>
          {loading && <div style={styles.dropdownMessage}>Loading distributors…</div>}
          {!loading && (
            <>
              {wineDistributors.length > 0 && (
                <>
                  <div style={styles.serviceSectionLabel}>Top Wine Distributors</div>
                  {wineDistributors.map((d, i) => (
                    <div key={i} style={styles.serviceCard}>
                      <div style={styles.serviceCardInfo}>
                        <div style={styles.serviceCardName}>{d.trade_name}</div>
                        {d.address && <div style={styles.serviceCardAddr}>{d.address}, {d.city}, {d.state} {d.zip_code}</div>}
                        {d.phone_number && (
							<a href={`tel:${d.phone_number}`} style={{ ...styles.serviceCardPhone, textDecoration: 'none' }}>
								📞 {formatPhone(d.phone_number)}
							</a>
						)}
                      </div>
                      <div style={styles.serviceCardBadge}>{d.brand_count} brands</div>
                    </div>
                  ))}
                </>
              )}
              {beerDistributors.length > 0 && (
                <>
                  <div style={styles.serviceSectionLabel}>Top Beer Distributors</div>
                  {beerDistributors.map((d, i) => (
                    <div key={i} style={styles.serviceCard}>
                      <div style={styles.serviceCardInfo}>
                        <div style={styles.serviceCardName}>{d.trade_name}</div>
                        {d.address && <div style={styles.serviceCardAddr}>{d.address}, {d.city}, {d.state} {d.zip_code}</div>}
                        {d.phone_number && <div style={styles.serviceCardPhone}>📞 {formatPhone(d.phone_number)}</div>}
                      </div>
                      <div style={styles.serviceCardBadge}>{d.brand_count} brands</div>
                    </div>
                  ))}
                </>
              )}
            </>
          )}
        </div>
      )}
    </>
  );
}

// ── Tab 1: Lookup ─────────────────────────────────────────────────────────────

function LookupTab() {
  const [lookupMode, setLookupMode] = useState('store');

  // Store search
  const [storeQuery, setStoreQuery] = useState('');
  const [storeResults, setStoreResults] = useState([]);
  const [storeLoading, setStoreLoading] = useState(false);
  const [selectedStore, setSelectedStore] = useState(null);
  const [storeFocused, setStoreFocused] = useState(false);
  const storeBlurTimer = useRef(null);

  // County search
  const [countyQuery, setCountyQuery] = useState('');
  const [countyResults, setCountyResults] = useState([]);
  const [countyLoading, setCountyLoading] = useState(false);
  const [selectedCounty, setSelectedCounty] = useState(null);
  const [countyFocused, setCountyFocused] = useState(false);
  const countyBlurTimer = useRef(null);

  // Brand search
  const [brandQuery, setBrandQuery] = useState('');
  const [brandResults, setBrandResults] = useState([]);
  const [brandLoading, setBrandLoading] = useState(false);
  const [brandFocused, setBrandFocused] = useState(false);
  const brandBlurTimer = useRef(null);

  const [distributorResult, setDistributorResult] = useState(null);
  const [resultLoading, setResultLoading] = useState(false);

  const debouncedStore = useDebounce(storeQuery, 280);
  const debouncedCounty = useDebounce(countyQuery, 280);
  const debouncedBrand = useDebounce(brandQuery, 280);

  const activeCounty = lookupMode === 'store'
    ? selectedStore?.county
    : selectedCounty?.license_county;

  const isReady = lookupMode === 'store' ? !!selectedStore : !!selectedCounty;
  const countyDisplayName = lookupMode === 'store'
    ? selectedStore?.county
    : selectedCounty?.display_name;

  // Store / address search
  useEffect(() => {
    if (!debouncedStore || debouncedStore.length < 2) { setStoreResults([]); return; }
    let cancelled = false;
    setStoreLoading(true);

    const query = supabase
      .from('licenses')
      .select('license, establishment_name, address, city, zip, county')
      .eq('beer_wine_status', 'Active')
      .order('establishment_name')
      .limit(20);

    if (lookupMode === 'store') {
      query.ilike('establishment_name', `%${debouncedStore}%`);
    } else if (lookupMode === 'address') {
      query.ilike('address', `%${debouncedStore}%`);
    }

    query.then(({ data, error }) => {
      if (cancelled) return;
      setStoreLoading(false);
      if (error) console.error('Store search error:', error);
      else setStoreResults(data || []);
    });

    return () => { cancelled = true; };
  }, [debouncedStore, lookupMode]);

  // County search
  useEffect(() => {
    if (!debouncedCounty || debouncedCounty.length < 2) { setCountyResults([]); return; }
    let cancelled = false;
    setCountyLoading(true);
    supabase
      .rpc('search_counties', { p_name: debouncedCounty })
      .then(({ data, error }) => {
        if (cancelled) return;
        setCountyLoading(false);
        if (error) console.error('County search error:', error);
        else setCountyResults(data || []);
      });
    return () => { cancelled = true; };
  }, [debouncedCounty]);

  // Brand search
  useEffect(() => {
    if (!debouncedBrand || debouncedBrand.length < 2 || !activeCounty) { setBrandResults([]); return; }
    let cancelled = false;
    setBrandLoading(true);
    supabase
      .rpc('search_brands_by_county', { p_county: activeCounty, p_brand_prefix: debouncedBrand })
      .then(({ data, error }) => {
        if (cancelled) return;
        setBrandLoading(false);
        if (error) console.error('Brand search error:', error);
        else setBrandResults(data || []);
      });
    return () => { cancelled = true; };
  }, [debouncedBrand, activeCounty]);

  const clearAll = useCallback(() => {
    setSelectedStore(null);
    setSelectedCounty(null);
    setStoreQuery('');
    setCountyQuery('');
    setStoreResults([]);
    setCountyResults([]);
    setBrandQuery('');
    setBrandResults([]);
    setDistributorResult(null);
  }, []);

  const handleModeSwitch = useCallback((mode) => {
    setLookupMode(mode);
    clearAll();
  }, [clearAll]);

  const handleSelectStore = useCallback((store) => {
    setSelectedStore(store);
    setStoreQuery('');
    setStoreResults([]);
    setBrandQuery('');
    setBrandResults([]);
    setDistributorResult(null);
  }, []);

  const handleSelectCounty = useCallback((county) => {
    setSelectedCounty(county);
    setCountyQuery('');
    setCountyResults([]);
    setBrandQuery('');
    setBrandResults([]);
    setDistributorResult(null);
  }, []);

  const handleSelectBrand = useCallback(async (brandName) => {
    setBrandQuery(brandName);
    setBrandResults([]);
    setResultLoading(true);
    setDistributorResult(null);
    const { data, error } = await supabase
      .rpc('get_distributor_by_brand_county', { p_county: activeCounty, p_brand: brandName });
    if (error) console.error('Distributor lookup error:', error);
    setResultLoading(false);
    setDistributorResult(data || []);
  }, [activeCounty]);

  const showStoreDrop = storeFocused && (storeLoading || storeResults.length > 0) && !selectedStore;
  const showCountyDrop = countyFocused && (countyLoading || countyResults.length > 0) && !selectedCounty;
  const showBrandDrop = brandFocused && (brandLoading || brandResults.length > 0);

  const isStoreMode = lookupMode === 'store' || lookupMode === 'address';
  const storeSelected = isStoreMode && selectedStore;
  const countySelected = lookupMode === 'county' && selectedCounty;

  return (
    <div style={styles.body}>
      <div style={styles.stepCard}>
        <div style={styles.stepLabel}>Step 1 — Find your location</div>
        <div style={styles.toggleRow}>
          <button style={{ ...styles.toggleBtn, ...(lookupMode === 'store' ? styles.toggleBtnActive : {}) }}
            onClick={() => handleModeSwitch('store')}>By Store</button>
          <button style={{ ...styles.toggleBtn, ...(lookupMode === 'address' ? styles.toggleBtnActive : {}) }}
            onClick={() => handleModeSwitch('address')}>By Address</button>
          <button style={{ ...styles.toggleBtn, ...(lookupMode === 'county' ? styles.toggleBtnActive : {}) }}
            onClick={() => handleModeSwitch('county')}>By County</button>
        </div>

        {/* Store or Address mode */}
        {isStoreMode && (
          storeSelected ? (
            <>
              <div style={styles.selectedPill}>
                <div style={styles.selectedInfo}>
                  <div style={styles.selectedName}>{selectedStore.establishment_name}</div>
                  <div style={styles.selectedSub}>{selectedStore.address}, {selectedStore.city} {selectedStore.zip} · {selectedStore.county}</div>
                </div>
                <button style={styles.clearBtn} onClick={clearAll}>×</button>
              </div>
              <WhoServicesMyStore county={selectedStore.county} />
            </>
          ) : (
            <div style={styles.inputWrap}>
              <SearchInput
                value={storeQuery}
                onChange={setStoreQuery}
                placeholder={lookupMode === 'address' ? 'Type street address…' : 'Type store name…'}
                focused={storeFocused}
                onFocus={() => { clearTimeout(storeBlurTimer.current); setStoreFocused(true); }}
                onBlur={() => { storeBlurTimer.current = setTimeout(() => setStoreFocused(false), 150); }}
              />
              {showStoreDrop && (
                <div style={styles.dropdown}>
                  {storeLoading && <div style={styles.dropdownMessage}>Searching…</div>}
                  {!storeLoading && storeResults.map(store => (
                    <div key={store.license} style={styles.dropdownItem}
                      onMouseDown={() => handleSelectStore(store)}
                      onMouseEnter={e => e.currentTarget.style.background = '#f7f7f5'}
                      onMouseLeave={e => e.currentTarget.style.background = 'transparent'}>
                      <div>{store.establishment_name}</div>
                      <div style={styles.dropdownItemSub}>{store.address}, {store.city} {store.zip} · {store.county}</div>
                    </div>
                  ))}
                  {!storeLoading && storeResults.length === 0 && debouncedStore.length >= 2 && (
                    <div style={styles.dropdownMessage}>No results found</div>
                  )}
                </div>
              )}
            </div>
          )
        )}

        {/* County mode */}
        {lookupMode === 'county' && (
          countySelected ? (
            <>
              <div style={styles.selectedPill}>
                <div style={styles.selectedInfo}>
                  <div style={styles.selectedName}>{selectedCounty.display_name}</div>
                </div>
                <button style={styles.clearBtn} onClick={clearAll}>×</button>
              </div>
              <WhoServicesMyStore county={selectedCounty.license_county} />
            </>
          ) : (
            <div style={styles.inputWrap}>
              <SearchInput
                value={countyQuery} onChange={setCountyQuery}
                placeholder="Type county or city…" focused={countyFocused}
                onFocus={() => { clearTimeout(countyBlurTimer.current); setCountyFocused(true); }}
                onBlur={() => { countyBlurTimer.current = setTimeout(() => setCountyFocused(false), 150); }}
              />
              {showCountyDrop && (
                <div style={styles.dropdown}>
                  {countyLoading && <div style={styles.dropdownMessage}>Searching…</div>}
                  {!countyLoading && countyResults.map(county => (
                    <div key={county.license_county} style={styles.dropdownItem}
                      onMouseDown={() => handleSelectCounty(county)}
                      onMouseEnter={e => e.currentTarget.style.background = '#f7f7f5'}
                      onMouseLeave={e => e.currentTarget.style.background = 'transparent'}>
                      {county.display_name}
                    </div>
                  ))}
                  {!countyLoading && countyResults.length === 0 && debouncedCounty.length >= 2 && (
                    <div style={styles.dropdownMessage}>No results found</div>
                  )}
                </div>
              )}
            </div>
          )
        )}
      </div>

      {/* Step 2 — Brand */}
      <div style={{ ...styles.stepCard, ...(!isReady ? styles.disabledCard : {}) }}>
        <div style={styles.stepLabel}>Step 2 — Search a brand</div>
        <div style={styles.inputWrap}>
          <SearchInput
            value={brandQuery}
            onChange={val => { setBrandQuery(val); if (!val) setDistributorResult(null); }}
            placeholder="Type brand name…" disabled={!isReady} focused={brandFocused}
            onFocus={() => { clearTimeout(brandBlurTimer.current); setBrandFocused(true); }}
            onBlur={() => { brandBlurTimer.current = setTimeout(() => setBrandFocused(false), 150); }}
          />
          {showBrandDrop && (
            <div style={styles.dropdown}>
              {brandLoading && <div style={styles.dropdownMessage}>Searching…</div>}
              {!brandLoading && brandResults.map(r => (
                <div key={r.brand_name} style={styles.dropdownItem}
                  onMouseDown={() => handleSelectBrand(r.brand_name)}
                  onMouseEnter={e => e.currentTarget.style.background = '#f7f7f5'}
                  onMouseLeave={e => e.currentTarget.style.background = 'transparent'}>
                  {r.brand_name}
                </div>
              ))}
              {!brandLoading && brandResults.length === 0 && debouncedBrand.length >= 2 && (
                <div style={styles.dropdownMessage}>No brands found in your county</div>
              )}
            </div>
          )}
        </div>
      </div>

      {/* Result */}
      {resultLoading && (
        <div style={styles.stepCard}>
          <div style={styles.dropdownMessage}>Looking up distributor…</div>
        </div>
      )}
      {!resultLoading && distributorResult !== null && (
        distributorResult.length === 0 ? (
          <div style={styles.stepCard}>
            <div style={styles.noResult}>No distributor found for this brand in {countyDisplayName}.</div>
          </div>
        ) : (
          distributorResult.map((dist, i) => (
            <div key={i} style={styles.resultCard}>
              <div style={styles.resultLabel}>Distributor in {countyDisplayName}</div>
              <div style={styles.resultBrand}>{brandQuery}</div>
              <div style={styles.divider} />
              <div style={styles.resultDistributor}>{dist.trade_name}</div>
              {dist.address && (
                <div style={styles.resultAddress}>
                  {dist.address}<br />{dist.city}, {dist.state} {dist.zip_code}
                </div>
              )}
              {dist.phone_number && (
				<a href={`tel:${dist.phone_number}`} style={{ ...styles.resultAddress, textDecoration: 'none' }}>
					<div style={styles.resultAddress}>📞 {dist.phone_number}</div>
				</a>
              )}
            </div>
          ))
        )
      )}
    </div>
  );
}

// ── Tab 2: Catalog ────────────────────────────────────────────────────────────

function CatalogTab() {
  const [distQuery, setDistQuery] = useState('');
  const [distResults, setDistResults] = useState([]);
  const [distLoading, setDistLoading] = useState(false);
  const [selectedDist, setSelectedDist] = useState(null);
  const [distFocused, setDistFocused] = useState(false);
  const distBlurTimer = useRef(null);

  const [brandList, setBrandList] = useState([]);
  const [brandListLoading, setBrandListLoading] = useState(false);
  const [page, setPage] = useState(0);
  const [hasMore, setHasMore] = useState(false);
  const [totalLoaded, setTotalLoaded] = useState(0);
  const [letterFilter, setLetterFilter] = useState(null);

  const [selectedBrand, setSelectedBrand] = useState(null);
  const [coverage, setCoverage] = useState([]);
  const [coverageLoading, setCoverageLoading] = useState(false);

  // Part territory modal
  const [partModal, setPartModal] = useState(null); // { brand, territory, displayName }

  const debouncedDist = useDebounce(distQuery, 280);

  useEffect(() => {
    if (!debouncedDist || debouncedDist.length < 2) { setDistResults([]); return; }
    let cancelled = false;
    setDistLoading(true);
    supabase
      .rpc('search_distributors', { p_name: debouncedDist })
      .then(({ data, error }) => {
        if (cancelled) return;
        setDistLoading(false);
        if (error) console.error('Distributor search error:', error);
        else setDistResults(data || []);
      });
    return () => { cancelled = true; };
  }, [debouncedDist]);

  const loadBrands = useCallback(async (tradeName, pageNum, letter = null) => {
    setBrandListLoading(true);
    const { data, error } = await supabase
      .rpc('get_brands_by_distributor', {
        p_trade_name: tradeName,
        p_limit: PAGE_SIZE,
        p_offset: pageNum * PAGE_SIZE,
        p_letter: letter,
      });
    if (error) { console.error('Brand list error:', error); setBrandListLoading(false); return; }
    const results = data || [];
    setBrandList(results);
    setHasMore(results.length === PAGE_SIZE);
    setTotalLoaded(pageNum * PAGE_SIZE + results.length);
    setBrandListLoading(false);
  }, []);

  const handleSelectDist = useCallback((tradeName) => {
    setSelectedDist(tradeName);
    setDistQuery('');
    setDistResults([]);
    setSelectedBrand(null);
    setCoverage([]);
    setPage(0);
    setLetterFilter(null);
    loadBrands(tradeName, 0, null);
  }, [loadBrands]);

  const handleLetterSelect = useCallback((letter) => {
    setLetterFilter(letter);
    setPage(0);
    setSelectedBrand(null);
    setCoverage([]);
    loadBrands(selectedDist, 0, letter);
  }, [selectedDist, loadBrands]);

  const handlePageChange = useCallback((newPage) => {
    setPage(newPage);
    setSelectedBrand(null);
    setCoverage([]);
    loadBrands(selectedDist, newPage, letterFilter);
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }, [selectedDist, loadBrands, letterFilter]);

  const handleSelectBrand = useCallback(async (brandName) => {
    if (selectedBrand === brandName) { setSelectedBrand(null); setCoverage([]); return; }
    setSelectedBrand(brandName);
    setCoverageLoading(true);
    setCoverage([]);
    const { data, error } = await supabase
      .rpc('get_coverage_by_distributor_brand', { p_trade_name: selectedDist, p_brand: brandName });
    if (error) console.error('Coverage error:', error);
    setCoverage(data || []);
    setCoverageLoading(false);
  }, [selectedDist, selectedBrand]);

  const handleClearDist = useCallback(() => {
    setSelectedDist(null);
    setDistQuery('');
    setDistResults([]);
    setBrandList([]);
    setSelectedBrand(null);
    setCoverage([]);
    setPage(0);
    setHasMore(false);
    setTotalLoaded(0);
    setLetterFilter(null);
  }, []);

  const showDistDrop = distFocused && (distLoading || distResults.length > 0) && !selectedDist;

  return (
    <div style={styles.body}>

      {/* Part territory modal */}
      {partModal && (
        <PartTerritoryModal
          brand={partModal.brand}
          territory={partModal.territory}
          displayName={partModal.displayName}
          onClose={() => setPartModal(null)}
        />
      )}

      <div style={styles.stepCard}>
        <div style={styles.stepLabel}>Search a distributor</div>
        {selectedDist ? (
          <div style={styles.selectedPill}>
            <div style={styles.selectedInfo}>
              <div style={styles.selectedName}>{selectedDist}</div>
            </div>
            <button style={styles.clearBtn} onClick={handleClearDist}>×</button>
          </div>
        ) : (
          <div style={styles.inputWrap}>
            <SearchInput
              value={distQuery} onChange={setDistQuery}
              placeholder="Type distributor name…" focused={distFocused}
              onFocus={() => { clearTimeout(distBlurTimer.current); setDistFocused(true); }}
              onBlur={() => { distBlurTimer.current = setTimeout(() => setDistFocused(false), 150); }}
            />
            {showDistDrop && (
              <div style={styles.dropdown}>
                {distLoading && <div style={styles.dropdownMessage}>Searching…</div>}
                {!distLoading && distResults.map(d => (
                  <div key={d.trade_name} style={styles.dropdownItem}
                    onMouseDown={() => handleSelectDist(d.trade_name)}
                    onMouseEnter={e => e.currentTarget.style.background = '#f7f7f5'}
                    onMouseLeave={e => e.currentTarget.style.background = 'transparent'}>
                    {d.trade_name}
                  </div>
                ))}
                {!distLoading && distResults.length === 0 && debouncedDist.length >= 2 && (
                  <div style={styles.dropdownMessage}>No distributors found</div>
                )}
              </div>
            )}
          </div>
        )}
      </div>

      {selectedDist && (
        <div style={styles.brandListWrap}>
          {/* Alphabet filter */}
          <div style={{ display: 'flex', flexWrap: 'wrap', gap: '6px', marginBottom: '12px' }}>
            {"ABCDEFGHIJKLMNOPQRSTUVWXYZ".split("").map(letter => (
              <button key={letter} style={{
                padding: '6px 10px', borderRadius: '6px', border: '1px solid #ccc',
                background: letterFilter === letter ? '#2D2A5E' : '#fff',
                color: letterFilter === letter ? '#fff' : '#333',
                cursor: 'pointer', fontSize: '12px', fontWeight: '600', fontFamily: 'inherit',
              }} onClick={() => handleLetterSelect(letter)}>{letter}</button>
            ))}
            <button style={{
              padding: '6px 10px', borderRadius: '6px', border: '1px solid #ccc',
              background: letterFilter === null ? '#2D2A5E' : '#fff',
              color: letterFilter === null ? '#fff' : '#333',
              cursor: 'pointer', fontSize: '12px', fontWeight: '600', fontFamily: 'inherit',
            }} onClick={() => handleLetterSelect(null)}>All</button>
          </div>

          {brandListLoading && <div style={styles.stepCard}><div style={styles.dropdownMessage}>Loading brands…</div></div>}
          {!brandListLoading && brandList.length === 0 && <div style={styles.stepCard}><div style={styles.noResult}>No brands found for this distributor.</div></div>}

          {!brandListLoading && brandList.length > 0 && (
            <>
              <div style={styles.paginationRow}>
                <button style={{ ...styles.pageBtn, ...(page === 0 ? styles.pageBtnDisabled : {}) }}
                  onClick={() => handlePageChange(page - 1)}>← Prev</button>
                <span style={styles.pageInfo}>{page * PAGE_SIZE + 1}–{totalLoaded} · Page {page + 1}</span>
                <button style={{ ...styles.pageBtn, ...(!hasMore ? styles.pageBtnDisabled : {}) }}
                  onClick={() => handlePageChange(page + 1)}>Next →</button>
              </div>

              {brandList.map(b => (
                <div key={b.brand_name}>
                  <div style={{ ...styles.brandRow, ...(selectedBrand === b.brand_name ? styles.brandRowActive : {}) }}
                    onClick={() => handleSelectBrand(b.brand_name)}>
                    <span>{b.brand_name}</span>
                    <span style={styles.brandRowChevron}>{selectedBrand === b.brand_name ? '▲' : '▼'}</span>
                  </div>

                  {selectedBrand === b.brand_name && (
                    <div style={styles.coverageWrap}>
                      {coverageLoading ? (
                        <div style={{ ...styles.dropdownMessage, color: 'rgba(255,255,255,0.4)' }}>Loading coverage…</div>
                      ) : coverage.length === 0 ? (
                        <div style={{ ...styles.dropdownMessage, color: 'rgba(255,255,255,0.4)' }}>No coverage data found.</div>
                      ) : (
                        <>
                          <div style={styles.coverageTitle}>Territory Coverage</div>
                          <div style={styles.coverageBrand}>{b.brand_name}</div>
                          {coverage.map((c, i) => (
                            <div key={i} style={styles.coverageRow}>
                              <div style={{ flex: 1 }}>
                                <div style={styles.coverageCounty}>{c.display_name}</div>
                              </div>
                              <div
                                style={{
                                  ...styles.coverageSection,
                                  ...(c.section === 'PART' ? styles.coverageSectionPart : styles.coverageSectionAll),
                                }}
                                onClick={c.section === 'PART' ? () => setPartModal({
                                  brand: b.brand_name,
                                  territory: c.franchise_territory || c.display_name,
                                  displayName: c.display_name,
                                }) : undefined}
                              >
                                {c.section}
                              </div>
                            </div>
                          ))}
                        </>
                      )}
                    </div>
                  )}
                </div>
              ))}

              <div style={styles.paginationRow}>
                <button style={{ ...styles.pageBtn, ...(page === 0 ? styles.pageBtnDisabled : {}) }}
                  onClick={() => handlePageChange(page - 1)}>← Prev</button>
                <span style={styles.pageInfo}>{page * PAGE_SIZE + 1}–{totalLoaded} · Page {page + 1}</span>
                <button style={{ ...styles.pageBtn, ...(!hasMore ? styles.pageBtnDisabled : {}) }}
                  onClick={() => handlePageChange(page + 1)}>Next →</button>
              </div>
            </>
          )}
        </div>
      )}
    </div>
  );
}

// ── Root App ──────────────────────────────────────────────────────────────────

export default function LookupApp() {
  const [activeTab, setActiveTab] = useState('lookup');
  return (
    <div style={styles.app}>
      <div style={styles.header}>
        <span style={styles.headerTitle}>Distributor Lookup</span>
      </div>
      <div style={styles.tabBar}>
        <button style={{ ...styles.tab, ...(activeTab === 'lookup' ? styles.tabActive : {}) }}
          onClick={() => setActiveTab('lookup')}>Lookup</button>
        <button style={{ ...styles.tab, ...(activeTab === 'catalog' ? styles.tabActive : {}) }}
          onClick={() => setActiveTab('catalog')}>Catalog</button>
      </div>
      {activeTab === 'lookup' ? <LookupTab /> : <CatalogTab />}
    </div>
  );
}
